import React from "react";
import { Col, Row } from "antd";
import NoDataPage from "../../NoDataPages/NoDataPage";
import noReview from "../../../assets/doctorIcons/noReview.svg";
import useIsMobile from "../../../hooks/useIsMobile";

export const isEmptySummaryHtml = (html) => {
  if (!html) return true;
  const text = (
    new DOMParser().parseFromString(String(html), "text/html").body
      ?.textContent || ""
  )
    .trim()
    .toLowerCase();
  return (
    !text ||
    text === "no summary available" ||
    text === "no summary available." ||
    text === "failed to load summary." ||
    text === "failed to load summary" ||
    text === "loading..."
  );
};

const OpSummaryEmptyState = ({
  title = "No summary",
  subtitle = "No EMR summary found for this patient",
}) => {
  const isMobile = useIsMobile();

  return (
    <Row
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: isMobile ? "auto" : "80vh",
        padding: isMobile ? "24px 0 32px" : undefined,
        width: "100%",
      }}
    >
      <Col span={24} style={{ textAlign: "center" }}>
        <NoDataPage title={title} subtitle={subtitle} image={noReview} />
      </Col>
    </Row>
  );
};

export default OpSummaryEmptyState;
